import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { cardCls, inputCls, labelCls } from "./ui";

const TEXT_FIELDS = [
  ["company_name", "Company Name"],
  ["contact_email", "Commercial Email (public)"],
  ["privacy_email", "Privacy / Legal Email"],
  ["phone", "Telephone"],
  ["whatsapp", "WhatsApp"],
  ["rfq_notify_email", "RFQ Notification Email (internal)"],
  ["marketing_sender_name", "Marketing Sender Name"],
  ["social_linkedin", "LinkedIn URL"],
  ["social_x", "X / Twitter URL"],
];
const AREA_FIELDS = [
  ["address", "Dubai Office / Operating Address (provisional)"],
  ["registered_address", "Registered Address (Ras Al Khaimah)"],
  ["footer_note", "Website Footer Copy"],
];

export const SettingsSection = () => {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/admin/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  if (!settings) return <p className="text-sm text-midnight/40 animate-pulse">Loading settings…</p>;

  const save = async () => {
    await api.put("/admin/settings", settings);
    toast.success("Settings saved");
  };

  return (
    <div className={`${cardCls} p-8 max-w-2xl space-y-5`} data-testid="admin-settings-form">
      <p className="text-xs text-midnight/45 leading-relaxed">
        Company identity and contact details used across the public site, RFQ and registration confirmations, and marketing correspondence. Empty contact fields stay unpublished.
      </p>
      {TEXT_FIELDS.map(([k, label]) => (
        <div key={k}>
          <label className={labelCls}>{label}</label>
          <input value={settings[k] || ""} onChange={(e) => setSettings((s) => ({ ...s, [k]: e.target.value }))} data-testid={`settings-${k}`} className={inputCls} />
        </div>
      ))}
      {AREA_FIELDS.map(([k, label]) => (
        <div key={k}>
          <label className={labelCls}>{label}</label>
          <textarea rows={4} value={settings[k] || ""} onChange={(e) => setSettings((s) => ({ ...s, [k]: e.target.value }))} data-testid={`settings-${k}`} className={inputCls} />
        </div>
      ))}
      <button onClick={save} data-testid="settings-save" className="bg-midnight text-white text-sm font-semibold px-8 py-3.5 hover:bg-midnight-light transition-colors">
        Save Settings
      </button>
    </div>
  );
};
